import { DatePipe } from '@angular/common';
import {Component,ElementRef,OnInit, ViewChild, ViewEncapsulation, ChangeDetectorRef} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { FilterMatchMode, LazyLoadEvent, SelectItem } from 'primeng/api';
import { Table } from 'primeng/table';
import { User } from 'src/app/auth/models';
import { JwtService } from 'src/app/auth/services';
import { IGlobalSearchParam, ISearchGlobalFilter } from 'src/app/shared/models/Global-Search.model';
import { SharedService } from 'src/app/shared/services';
import { IErrorLogReport } from '../../models';
import { ErrorLogService } from '../../services/error-log.service';
import * as XLSX from 'xlsx';
import * as fs from 'file-saver';
import {DialogService} from 'primeng/dynamicdialog';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';
import { ErrorLogViewModalComponent } from '../error-log/error-log-view-modal/error-log-view-modal.component';

@Component({
  selector: 'app-error-log',
  templateUrl: './error-log.component.html',
  styleUrls: ['./error-log.component.css'],
  providers: [DialogService, ConfirmationService, MessageService],

})
export class ErrorLogComponent implements OnInit {
  errorLogReportForm : FormGroup;
  sortField:string = 'createdOn';
  sortOrder:string = 'desc';
  oldSortField:string = 'createdOn';
  oldSortOrder:string = 'desc';
  appliedFilters:{field:string,matchMode:string,value:string}[]=[];
  pageNo: number =1;
  pageSize: number =10;
  oldPageNo: number =1;
  oldPageSize: number =10;
  totalRecords: number;
  loadEvent: LazyLoadEvent;
  filters;
  filterCondition: { fieldName: string; type: string; }[] =[];
  // matchModeOptions: SelectItem[];
  // matchModeOptionsForDate: SelectItem[];
  // matchModeOptionsForNumeric: SelectItem[];
  // matchModeOptionsForDropdown: SelectItem[];
  showFilters:boolean;
  showSorting:boolean;
  errorLogReportSearchParam:IGlobalSearchParam;
  showAddRuleButton:boolean = false;
  searchGlobalFilter: ISearchGlobalFilter[]=[];
  userActivityLogList;
  isshowpaginator:boolean=true;
  loggedInUserProfile: User;
  dateRange:Date[];
  minDate: Date;
  maxDate: Date;
  categoryName;
  startDate;
  endDate;
  showTable:boolean = false;
  emailDeliveryReport = 'ErrorLogReport.xlsx';
  allColumns = [
    { value: '#', header: '#' },
    { value: 'id', header: 'ID' },
    { value: 'logged', header: 'Logged' },
    { value: 'level', header: 'Level' },
    { value: 'message', header: 'Message' },
    { value: 'logger', header: 'Logger' },
    { value: 'properties', header: 'Properties' },
    { value: 'callsite', header: 'Call Site' },
    { value: 'exception', header: 'Exception' },
    { value: 'userAgent', header: 'User Agent' },
    { value: 'ipAddress', header: 'IP Address' },
    { value: 'requestUrl', header: 'Request URL' },
    { value: 'queryString', header: 'Query String' },
    { value: 'apiMethod', header: 'API Method' },
    { value: 'postedBody', header: 'Posted Body' },


  ];

  selectedColumns = [
    { value: '#', header: '#' },
    { value: 'id', header: 'ID' },
    { value: 'logged', header: 'Logged' },
    { value: 'level', header: 'Level' },
    { value: 'message', header: 'Message' },
    { value: 'logger', header: 'Logger' },
    { value: 'properties', header: 'Properties' },
    { value: 'callsite', header: 'Call Site' },
    { value: 'exception', header: 'Exception' },
    { value: 'userAgent', header: 'User Agent' },
    { value: 'ipAddress', header: 'IP Address' },
    { value: 'requestUrl', header: 'Request URL' },
    { value: 'queryString', header: 'Query String' },
    { value: 'apiMethod', header: 'API Method' },
    { value: 'postedBody', header: 'Posted Body' },
  ];
  errorLogReportSpinner = 'errorLogReportSpinner';
  @ViewChild('dt2', { static: true }) table: any;
  startDateFilterValue: any;
  endDateFilterValue: any;
  loggedDateFilterValue: any;
  showToggle:boolean;
  errorLogReportList;
  ref: DynamicDialogRef;

  constructor(
    private errorLogService: ErrorLogService,
    public sharedService: SharedService,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    public datePipe: DatePipe,
    private dialogService: DialogService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private jwtService: JwtService,
    private router: Router,
  ) { 
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 1000);
   }

  ngOnInit(): void {

    this.checkViewPermission();
    this.reactiveForm();
    this.maxDate = new Date();
    this.loggedInUserProfile = this.sharedService.getLoggedInUserProfile();
   
    this.filterCondition=[
      {fieldName:"id", type:"basic"},
      {fieldName:"logged", type:"date"},
      {fieldName:"level", type:"basic"},
      {fieldName:"message", type:"basic"},
      {fieldName:"logger", type:"basic"},
      {fieldName:"properties", type:"basic"},
      {fieldName:"callsite", type:"basic"},
      {fieldName:"exception", type:"basic" },
      {fieldName:"userAgent", type:"basic" },
      {fieldName:"ipAddress", type:"basic" },
      {fieldName:"requestUrl", type:"basic" },
      {fieldName:"queryString", type:"basic" },
      {fieldName:"apiMethod", type:"basic" },
      {fieldName:"postedBody", type:"basic" },

    ];
    this.getErrorLogReport()
  }

  reactiveForm(){
    this.errorLogReportForm = this.formBuilder.group({
      startDate : new FormControl(null, [Validators.required]),
      endDate : new FormControl(null, [Validators.required]),
    })
    }

    isShowColumns(columnName){
      var tempColumn = this.selectedColumns.filter(col => col.value == columnName);
      if(tempColumn.length == 1){
        return true;
      }
      return false;
    }
    checkViewPermission() {
      var permission =this.jwtService.getLoggedInUserProfile();
      var allowedUser = this.sharedService.isMspUser();
      if(permission ==0 || allowedUser == false || allowedUser == undefined)
      {
       this.router.navigateByUrl('/login');
      }
    }
    onSelectStartDate(event) {
      this.maxDate = new Date(this.datePipe.transform(event, 'yyyy-MM-dd'));
    }

    loadErrorLogReportList(event:LazyLoadEvent)
  { 
    this.loadEvent=event;
    if(event.first==0)
    {
      this.pageNo = 1;
    }
    else {
      this.pageNo=(event.first/event.rows)+1;
    }
    this.pageSize=event.rows;
    
    this.pageSize=event.rows;
    
    if((this.oldPageNo != this.pageNo) || (this.oldPageSize != this.pageSize))
    {
      this.applyFilter();
      this.getErrorLogReport();
    }
    this.oldPageNo = this.pageNo;
    this.oldPageSize = this.pageSize;
    this.filters=event.filters;
   
    if(this.filters["createdOn"] != undefined)
    {
    if(this.filters["createdOn"][0].matchMode == "date-after")
    {
       this.showAddRuleButton = true;
    }
    else{
      this.showAddRuleButton = false;
    }
  }
    this.sortField=event.sortField;
    if(event.sortField === undefined || event.sortField === null)
    {
      this.sortField='createdOn';
    }
    if(event.sortOrder === 1)
    {
    this.sortOrder='desc';
    }
    if(event.sortOrder === -1)
    {
    this.sortOrder='asc';
    }
    if(this.oldSortField !==  this.sortField ||  this.oldSortOrder !== this.sortOrder)
    {
      this.applyFilter();
      this.getErrorLogReport();
    }
    this.oldSortField = this.sortField;
    this.oldSortOrder = this.sortOrder;
  }

  generateErrorLogReport({ value } : { value: IErrorLogReport}, table:Table){
    table.clear();
    // this.startDateFilterValue = undefined;
    // this.endDateFilterValue = undefined;
    this.appliedFilters=[];
    this.startDate = value.startDate;
    this.endDate = value.endDate;
    this.appliedFilters.push({ field:"loggedInUserId", matchMode:"custom-equals", value:this.loggedInUserProfile.uid }); 
    this.showTable = true;
    this.getErrorLogReport();
  }

  getErrorLogReport(){
    // if(this.startDate !=undefined)
    // {
    //   this.appliedFilters.push({ field:"startDate", matchMode:"custom-equals", value:this.datePipe.transform(this.startDate,"MM-dd-yyyy")});
    // }
    // if(this.endDate !=undefined)
    // {
    //   this.appliedFilters.push({ field:"endDate", matchMode:"custom-equals", value:this.datePipe.transform(this.endDate,"MM-dd-yyyy")}); 
    // }
    // this.appliedFilters=[];
    this.appliedFilters.push({ field:"loggedInUserId", matchMode:"custom-equals", value:this.loggedInUserProfile.uid }); 
    this.showTable = true;
    this.errorLogReportSearchParam = 
    {
      pageNo:this.pageNo,
         pageSize:this.pageSize,
         sortField:this.sortField,
         appliedFilters:this.appliedFilters,
         searchGlobalFilter: this.searchGlobalFilter,
         sortOrder:this.sortOrder
    }
    console.log('parma',this.errorLogReportSearchParam)
       this.spinner.show();
    this.errorLogService.searchErrorLogReport(this.errorLogReportSearchParam).subscribe((data: any) => {
      this.appliedFilters = [];
      this.errorLogReportList =data;
      console.log('vn',this.errorLogReportList);
      this.isshowpaginator=this.errorLogReportList.length>0?true:false;
      this.totalRecords = (this.errorLogReportList === null || this.errorLogReportList === undefined || this.errorLogReportList.length <= 0 )? 0 : data[0].totalCount;
      console.log(this.totalRecords);
      this.spinner.hide();
     });
  }
  clear(table:Table)
  {
    console.log(table);
    table.clear();
    this.reactiveForm();
    this.appliedFilters = [];
    this.errorLogReportList =[];
    this.isshowpaginator=false;
    this.loggedDateFilterValue = undefined;
    // this.startDateFilterValue = undefined;
    // this.endDateFilterValue = undefined;
    // this.pageNo =1;
    // this.pageSize =10;
    // this.oldPageNo =1;
    // this.oldPageSize =10;
    // this.totalRecords = 0;
    // this.sortField = 'createdOn';
    // this.sortOrder = 'desc';
    // this.oldSortField = 'createdOn';
    // this.oldSortOrder = 'desc';
    this.showTable = false;
  }

  applyFilterNew() {
    this.pageNo = 1;
    this.table.first = 0;
    this.applyFilter();
  }

  applyFilter() {
    //  console.log(this.filters);
    if (Object.keys(this.filters).length > 1) {
      this.appliedFilters = [];
      for (let i = 0; i < this.filterCondition.length; i++) {
        if (this.filterCondition[i].type == "checkbox") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value == true) {
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: "true"
              })
            }
            else if (this.filters[this.filterCondition[i].fieldName][0].value == false) {
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: "false"
              })
            }
          }
        }
        else if (this.filterCondition[i].type == "basic") {
          console.log("filter type is basic");
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value !== null) {
              console.log("filter field name is " + [this.filterCondition[i].fieldName][0]);
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: this.filters[this.filterCondition[i].fieldName][0].value
              })
            }
          }
        }
        else if (this.filterCondition[i].type == "date") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            // for (let j = 0; j <= this.filters[this.filterCondition[i].fieldName].length - 1; j++) {
            //   if (this.filters[this.filterCondition[i].fieldName][j].value !== null)
            //     this.appliedFilters.push({
            //       field: this.filterCondition[i].fieldName,
            //       matchMode: this.filters[this.filterCondition[i].fieldName][j].matchMode,
            //       value: this.datePipe.transform(this.filters[this.filterCondition[i].fieldName][j].value, "MM-dd-yyyy")
            //     })
            // }
            if (this.filterCondition[i].fieldName == "logged") {
              this.dateFilterValueSet(this.loggedDateFilterValue, "logged")
            }

            // if (this.filterCondition[i].fieldName == "startDate") {
            //   this.dateFilterValueSet(this.startDateFilterValue, "startDate")
            // }

            // if (this.filterCondition[i].fieldName == "endDate") {
            //   this.dateFilterValueSet(this.endDateFilterValue, "startDate")
            // }
            
          }
        }
        else if (this.filterCondition[i].type == "numeric") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value !== null)
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: this.filters[this.filterCondition[i].fieldName][0].value
              })
          }
        }
        else if (this.filterCondition[i].type == "dropdown") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value !== null) {
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: this.filters[this.filterCondition[i].fieldName][0].value
              })
            }
          }
        }
      }
  this.getErrorLogReport();
    }
  }

  clearFilter(table: Table) {
    for (let i = 0; i < this.filterCondition.length; i++) {
      if (this.table.filters[this.filterCondition[i].fieldName] != undefined) {
       this.table.filters[this.filterCondition[i].fieldName][0].value = null;
      }
    }
    table.clear();
    this.appliedFilters = [];
    this.loggedDateFilterValue = undefined;
    // this.startDateFilterValue = undefined;
    // this.endDateFilterValue = undefined;
    // this.applyFilter();
    this.getErrorLogReport();
  }

  exportErrorLogReport(){
    if(this.startDate !=undefined)
    {
      this.appliedFilters.push({ field:"startDate", matchMode:"custom-equals", value:this.datePipe.transform(this.startDate,"MM-dd-yyyy")});
    }
    if(this.endDate !=undefined)
    {
      this.appliedFilters.push({ field:"endDate", matchMode:"custom-equals", value:this.datePipe.transform(this.endDate,"MM-dd-yyyy")}); 
    }

    this.applyFilter();
    this.errorLogReportSearchParam = 
       {
         pageNo:this.pageNo,
         pageSize:this.pageSize,
         sortField:this.sortField,
         appliedFilters:this.appliedFilters,
         searchGlobalFilter: this.searchGlobalFilter,
         sortOrder:this.sortOrder
       };
       this.spinner.show();
    this.errorLogService.exportErrorLogReport(this.errorLogReportSearchParam).subscribe(res => {
      var blob = new Blob([res.body], { type: res.body.type });
      const file = new File([blob],"ErrorLogReport.xlsx", { type: res.body.type });
      fs.saveAs(file);
      });
      this.spinner.hide();
  }
  loggedDateFilterData(e: any) {
    this.loggedDateFilterValue = e;
    this.applyFilterNew();
  }
  dateFilterValueSet(value, fieldName) {
    if (value !== undefined) {
      for (let j = 0; j < value.length; j++) {
        if (value[j].valueControl !== null) {
          this.appliedFilters.push({
            field: fieldName,
            matchMode: value[j].matchModeControl,
            value: this.datePipe.transform(value[j].valueControl, "MM-dd-yyyy")
          })
        }
      }
    }
  }
  showErrorLogDetails(paramId: number) {
    this.ref = this.dialogService.open(ErrorLogViewModalComponent, {
      header: 'Error Log Details',
      width: '300%',
      contentStyle: { "max-height": "500px", "overflow": "auto" },
      baseZIndex: 10000,
      data: { id: paramId }
    });
  }
}
